import React, { useState } from 'react';
import FormField from '../../../components/FormField';
import { wordCharacterCount } from '../../../utils/wordCharacterCount.utils';
import { LCInput } from '../../../frameWork';
import style from "../style.scss";

export const MetaData = props => {

  const [wordLength, setWordLength] = useState('0/0');


  const generateCharacterWordCountTextArea = (e) => {
    props.onPageTitleChange(e)
    const { wordCount, charCount } = wordCharacterCount(e.target.value);
    setWordLength(
      `${wordCount}/${charCount}`
    )
  }





  return (<div className="domainlevel-upload">
    <h3 style={{ marginBottom: "10px" }}>Domain & Contact Details</h3>
    <div className='replace-logo' style={{ width: '200rem' }}>
      <div className='upload-type'>
        <FormField
          name={'page-title'}
          title={'Page Title'}
          onChange={(e) => generateCharacterWordCountTextArea(e)}
          value={props.pageTitle ? props.pageTitle : ''}
          limit={false}
        />
        <div className='infoPane'>
          <span className='textRight'>{wordLength}</span>
        </div>
      </div>
      <div style={{ marginTop: '1rem' }}>
        <FormField
          inputType={'textArea'}
          name={'template-area-input'}
          title={'Page Description'}
          onChange={props.onPageDescriptionChange}
          value={props.pageDescription ? props.pageDescription : ''}
          limit={false}
          showCounter={true}
        />
      </div>
      <div style={{ marginTop: '1rem' }}>
        <FormField
          name={'support-address'}
          title={'Support Email Address'}
          value={props.supportEmail ? props.supportEmail : ''}
          onChange={(e) => props.onSupportEmailChange(e)}
          maxLength={150000}
        />
      </div>
      <div style={{ marginTop: '1rem' }}>

        <FormField
          name={'from-name'}
          title={'From Name'}
          value={props.fromName ? props.fromName : ''}
          onChange={(e) => props.onWhiteLabelDetailsChange(e.target.value.trim(), 'fromName')}
          maxLength={150000}
        />
      </div>
      <div style={{ marginTop: '1rem' }}>
        <FormField
          name={'from-address'}
          title={'From Address'}
          value={props.fromAddress ? props.fromAddress : ''}
          onChange={(e) => props.onWhiteLabelDetailsChange(e.target.value.trim(), 'fromAddress')}
          maxLength={150000}
        />
      </div>
      <div style={{ marginTop: '1rem' }}>

        <FormField
          name={'from-review-address'}
          title={'From Review Address'}
          value={props.fromReviewAddress ? props.fromReviewAddress : ''}
          onChange={(e) => props.onWhiteLabelDetailsChange(e.target.value.trim(), 'fromReviewAddress')}
          maxLength={150000}
        />
      </div>
      <div style={{ marginTop: '1rem' }}>
        <span>Address</span>
        <div style={{ marginTop: '0.5rem' }}>
          <FormField name={'address-line'} title={'Address line'} onChange={(e) => props.onAddressLineChange(e)} value={props.addressLine ? props.addressLine : ''} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ width: "48%" }}>
            <div style={{ marginTop: '1rem' }}>
              <FormField name={'city'} title={'City'} onChange={(e) => props.onCityChange(e)} value={props.city ? props.city : ''} />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <FormField name={'state'} title={'State'} onChange={(e) => props.onStateNameChange(e)} value={props.stateName ? props.stateName : ''} />
            </div>
          </div>
          <div style={{ width: "48%" }}>
            <div style={{ marginTop: '1rem' }}>
              <FormField name={'country'} title={'Country'} onChange={(e) => props.onCountryChange(e)} value={props.country ? props.country : ''} />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <FormField name={'zip-code'} title={'ZIP Code'} onChange={(e) => props.onZipCodeChange(e)} value={props.zipCode ? props.zipCode : ''} />
            </div>
          </div>
        </div>
        <div style={{ marginTop: '1rem' }}>
          <div>
            <FormField
              name={'profile-notification-email'}
              title={'New Profile Notification Emails'}
              value={props.profileNotificationEmail ? props.profileNotificationEmail : ''}
              onChange={(e) => props.onProfileNotificationEmailChange(e)}
              maxLength={150000}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            <FormField
              name={'user-notification-email'}
              title={'New User Notification Emails'}
              value={props.userNotificationEmail ? props.userNotificationEmail : ''}
              onChange={(e) => props.onUserNotificationEmailChange(e)}
              maxLength={150000}
            />
          </div>
        </div>
      </div>
    </div>
  </div>)
}